import { gql } from '@apollo/client';

export const GET_ORGANIZATION_OPTIONS = gql`
    query getOrganizationOptions {
        audiencesRetention
    }
`;
